import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PopoverController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { OverlayEventDetail } from '@ionic/core/components';
import { AboutModalComponent } from 'src/app/components/about-modal/about-modal.component';

@Component({
  selector: 'app-setting-menu',
  templateUrl: './setting-menu.component.html',
  styleUrls: ['./setting-menu.component.scss'],
  
})
export class SettingMenuComponent {
  @Input() hasAppLock = false;

  constructor(
    private router: Router,
    public storageService: StorageService,
    private toastService: ToastService,
    public popoverController: PopoverController, 
    public modalController: ModalController 
  ) { }

  onSelect(option) {
    if (option == "help")
    {
      this.storageService.set('help_return', 'home');
      this.router.navigate(['/tutorial']);
    }
    if (option == "helpvideos")
    {
      this.router.navigate(['/helpvideos']);
    }
    
    this.popoverController.dismiss(option);
  }

  presentModal() {
    this.popoverController.dismiss();
    this.popoverController.create({
      component: AboutModalComponent,
      cssClass: 'billing-modal',
      mode:'ios',
      showBackdrop: true,
      backdropDismiss: true
    }).then(res => {
      res.present();      
    });
  }
}
